import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';
import { BaseService } from 'src/app/core/services/base.service';
import { Config } from 'src/app/config/constants';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-report-details',
  templateUrl: './report-details.component.html',
  styleUrls: ['./report-details.component.scss'],
  providers: [DatePipe],
})
  export class ReportDetailsComponent implements OnInit {
    reportType:any;
    statement_date:any;
    application_date_from = '';
    application_date_to = ''
    report_format:any='pdf';
    StatementDate = [];
    ApplicationDateFrom = [
      'May 2022',
      'April 2022',
      'March 2022',
      'Feb 2022',
      'Jan 2022',
      'December 2022'
    ];
    ApplicationDateTo = [
      'May 2022',
      'April 2022',
      'March 2022',
      'Feb 2022',
      'Jan 2022',
      'December 2022'
    ]
    ReportFormat = [
      {
        name: "Acrobat(PDF) file",
        type: 'pdf',
      },
      {
        name: "Excel",
        type: 'excel',
      }
    ];
    hideQuotePurchase:any;
    agentId:string;
    maxDate = new Date();
    leadType:any;
    commitionToOfLead:any;
    checkOVRInAgencyCode: any;
  agentIdActive: string;
  leadsId: string;
  leadStatus: any;
    constructor(private router: Router,public user: UserService,private datePipe: DatePipe,private base: BaseService,private config:Config) { }
  
  ngOnInit(): void {
    this.leadsId=sessionStorage.getItem('leadId');
    this.reportType=localStorage.getItem('report-type');
    this.hideQuotePurchase=sessionStorage.getItem('hideQuotePurchase');
    this.checkOVRInAgencyCode=sessionStorage.getItem('checkOVRInAgencyCode');
    this.agentId=sessionStorage.getItem('agentIdSalesPortal');
    this.leadType=sessionStorage.getItem('leadtype')
    this.commitionToOfLead=sessionStorage.getItem('commitionToOfLead')
    this.maxDate.setHours(0, 0, 0, 0);
    this.getCommissionStatementDates();
    this.getLeadAgentsCodes()
    this.getDashboard();
  }
  
  download(){
    this.application_date_from = this.datePipe.transform(this.application_date_from, "yyyy-MM-dd");
    this.application_date_to = this.datePipe.transform(this.application_date_to, "yyyy-MM-dd");
    if(this.reportType == 'Broker Commission Statement'){
      if((this.leadType=='Agency Rep' && this.commitionToOfLead=='Agency') || (this.leadType=='Company Rep' && this.commitionToOfLead=='Agency') || (this.leadType=='Travel Agency Rep'  && this.commitionToOfLead=='Agency') || (this.leadType=='General Agency Rep' && this.commitionToOfLead=='Agency')){
        this.agencyCommissionsPdf()
      }else{
        this.brokerCommissionPdf();
      }
    }
    if(this.reportType == 'Broker Sales Report'){
      if((this.leadType=='Agency Rep' && this.commitionToOfLead=='Agency') || (this.leadType=='Company Rep' && this.commitionToOfLead=='Agency') || (this.leadType=='Travel Agency Rep'  && this.commitionToOfLead=='Agency') || (this.leadType=='General Agency Rep' && this.commitionToOfLead=='Agency')){
        this.agencySalesPdf()
      }else{
        this.brokerSalesPdf();
      }
    }
    if(this.reportType == 'MGA Commission'){
      this.mgaCommissiontoBrokerPdf();
    }
    if(this.reportType == 'MGA Sales by Broker'){
      if(this.leadType=='MGA Rep' && this.commitionToOfLead=='MGA'){
        this.mgaCommissionForOVR();
      }else{
        this.mgaOvrSalesbyBroker();
      }
    }
    if(this.reportType == 'MGA OVR Commission Statement'){
      this.mgaOvrcommission();
    }
  }
  goToReportTab(){
    this.router.navigate(['/dashboard/sales-report']);
  }
  ngOnDestroy(){
    localStorage.removeItem('report-type');
  }
  isDisabled: boolean = false;
  goToQuotePurchase(){
    if(this.isDisabled){
      return;
    }
    if(this.hideQuotePurchase!="true" && this.agentIdActive=='true'){
      this.router.navigateByUrl('/dashboard/Quotes-Purchase');
    }else{
      if(this.hideQuotePurchase=="true"){
      Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
    }
    }
  }
  brokerSalesPdf(){
    var flag=true
    if(!this.report_format){flag=false}
    if(!this.statement_date){flag=false}
    if(flag==true){
    const request = {
      "agentId":  this.agentId,
      "fileType": this.report_format,
      "fromDate": "",
      "statementLogId": this.statement_date,
      "toDate": "",
      "titleName": this.reportType
    }
    this.base.callPostService(this.config.v2BrokerSales, request).subscribe((data:any) =>{
      if(data.status==true){
        saveAs(data.data,"Broker Sales Report");
      }
    },error=>{{
    }},()=>{});
    }else{
      Swal.fire('',"Please select all fields.",'error')
    }
  }
  brokerCommissionPdf(){
    var flag=true
    if(!this.report_format){flag=false}
    if(!this.statement_date){flag=false}
    if(flag==true){
    const request = {
      "agentId": this.agentId,
      "date": "",
      "fileType": this.report_format,
      "fromDate": "",
      "monthYear": "",
      "policyStatementId": 0,
      "statementLogId": this.statement_date,
      "toDate": "",
      "titleName": this.reportType
    }
    this.base.callPostService(this.config.v2BrokerCommission, request).subscribe((data:any) =>{
      if(data.status==true){
        saveAs(data.data,"Broker Commission Statement");  
      }
    },error=>{{
    }},()=>{});
    }else{
      Swal.fire('',"Please select all fields.",'error')
    }
  }
  mgaCommissiontoBrokerPdf(){
    var flag=true
    if(!this.report_format){flag=false}
    if(!this.statement_date){flag=false}
    if(flag==true){
    const request = {
      "agentId": this.agentId,
      "date": "",
      "fileType": this.report_format,
      "fromDate": "",
      "monthYear": "",
      "policyStatementId": 0,
      "statementLogId": this.statement_date,
      "toDate": "",
      "titleName": this.reportType
    }
    this.base.callPostService(this.config.v2MgaCommission, request).subscribe((data:any) =>{
      if(data.status==true){
        if(this.reportType == 'MGA Commission'){
          saveAs(data.data,"MGA Commission"); 
        }
      }
    },error=>{{
    }},()=>{});
    }else{
      Swal.fire('',"Please select all fields.",'error')
    }
  }
  mgaCommissionPdf(){
    var flag=true
    if(!this.report_format){flag=false}
    if(!this.statement_date){flag=false}
    if(flag==true){
    const request = {
      "agentId": this.agentId,
      "fileType": this.report_format,
      "fromDate": "",
      "statementLogId": this.statement_date,
      "toDate": "",
      "titleName": this.reportType
    }
    this.base.callPostService(this.config.v2MgaSales, request).subscribe((data:any) =>{
      if(data.status==true){
        saveAs(data.data,"MGA Sales by Broker"); 
      }
    },error=>{{
    }},()=>{});
    }else{
      Swal.fire('',"Please select all fields.",'error')
    }
  }
  getCommissionStatementDates(){
    this.base.callGetServiceCall(this.config.getCommissionStatementDates).subscribe((data:any) =>{
      
      if(data.data.length!=0){
        this.StatementDate=data?.data;
        this.statement_date=this.StatementDate[0]?.statmentDate
      }else{

      }

    },error=>{{
    }},()=>{});
  }
  agencyCommissionsPdf(){
    var flag=true
    if(!this.report_format){flag=false}
    if(!this.statement_date){flag=false}
    if(flag==true){
    const request = {
      "agentId": this.agentId,
      "date": "",
      "fileType": this.report_format,
      "fromDate": "",
      "monthYear": "",
      "policyStatementId": 0,
      "statementLogId": this.statement_date,
      "toDate": "",
      "titleName": this.reportType
    }
    this.base.callPostService(this.config.v2AgencyCommission, request).subscribe((data:any) =>{
      if(data.status==true){
        saveAs(data.data,"Broker Commission Statement"); 
      }
    },error=>{{
    }},()=>{});
    }else{
      Swal.fire('',"Please select all fields.",'error')
    }
  }
  agencySalesPdf(){
    var flag=true
    if(!this.report_format){flag=false}
    if(!this.statement_date){flag=false}
    if(flag==true){
    const request = {
      "agentId": this.agentId,
      "fileType": this.report_format,
      "fromDate": "",
      "statementLogId": this.statement_date,
      "toDate": "",
      "titleName": this.reportType
    }
    this.base.callPostService(this.config.v2AgencySales, request).subscribe((data:any) =>{
      if(data.status==true){
        saveAs(data.data,"Broker Sales Report"); 
      }
    },error=>{{
    }},()=>{});
    }else{
      Swal.fire('',"Please select all fields.",'error');
    }
  }
  mgaCommissionForOVR(){
    var flag=true
    if(!this.report_format){flag=false}
    if(!this.statement_date){flag=false}
    if(flag==true){
    const request = {

      "agentId": this.agentId,
      "date": "",
      "fileType": this.report_format,
      "fromDate": "",
      "mgaId": 0,
      "monthYear": "",
      "policyStatementId": 0,
      "runStatementId": 0,
      "statementLogId": this.statement_date,
      "toDate": "",
      "titleName": this.reportType
    }
    this.base.callPostService(this.config.mgaCommissionBrokerForOVR, request).subscribe((data:any) =>{
      if(data.status==true){
        saveAs(data.data,"MGA Sales by Broker"); 
      }
    },error=>{{
    }},()=>{});
    }else{
      Swal.fire('',"Please select all fields.",'error')
    }
  }
  mgaOvrSalesbyBroker(){
    var flag=true
    if(!this.report_format){flag=false}
    if(!this.statement_date){flag=false}
    if(flag==true){
    const request = {
      "agentId": this.agentId,
      "date": "",
      "fileType": this.report_format,
      "fromDate": "",
      "mgaId": 0,
      "monthYear": "",
      "policyStatementId": 0,
      "runStatementId": 0,
      "statementLogId": this.statement_date,
      "titleName": this.reportType,
      "toDate": ""
    }
    this.base.callPostService(this.config.mgaOvrSalesbyBroker, request).subscribe((data:any) =>{
      if(data.status==true){
        saveAs(data.data,"MGA Sales by Broker"); 
      }
    },error=>{{
    }},()=>{});
    }else{
      Swal.fire('',"Please select all fields.",'error')
    }
  }
  mgaOvrcommission(){
    var flag=true
    if(!this.report_format){flag=false}
    if(!this.statement_date){flag=false}
    if(flag==true){
    const request = {
      "agentId": this.agentId,
      "date": "",
      "fileType": this.report_format,
      "fromDate": "string",
      "mgaId": 0,
      "monthYear": "string",
      "policyStatementId": 0,
      "runStatementId": 0,
      "statementLogId": this.statement_date,
      "titleName": this.reportType,
      "toDate": ""
    }
    this.base.callPostService(this.config.mgaOvrcommission, request).subscribe((data:any) =>{
      if(data.status==true){
        saveAs(data.data,"MGA OVR Commission Statement"); 
      }
    },error=>{{
    }},()=>{});
    }else{
      Swal.fire('',"Please select all fields.",'error')
    }
  }
  getLeadAgentsCodes(){
    this.user.getLeadAgentsCodes(this.leadsId).pipe()
    .subscribe(
      data => {
      // console.log(data);
      // this.agentcodedata=[];
    ////
      // this.agentIdActive=sessionStorage.getItem('agentIdActive');
      for(let i=0;i<data.data.agentCodes.length;i++){
        if(this.agentId==data.data.agentCodes[i].id){
          if(data.data.agentCodes[i].status=="Active" || data.data.agentCodes[i].status=="Primary")
          {
          this.agentIdActive='true'
          }
          else{
            this.agentIdActive='false'
          }
        }
       // this.agentcodedata.push(data.data.agentCodes[i])
        // console.log(this.agentcodedata)
      }
      }, error => {
  
        // if (error.status == 400 || error.status == 417) {
        //   this.error = error.error.data;
        // }
        // else {
        //   this.error = "Something went wrong. Please check username and password.";
        // }
      }, () => { });
    }
    goToSalesHome(){
      if(this.agentIdActive=='true'){
        this.router.navigateByUrl('/dashboard/sales-home');
      }else{
        // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
      }

    }
goToPolicySearch(){
  if(this.agentIdActive=='true'){
    this.router.navigateByUrl('/dashboard/policy-search');
  }else{
    // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
  }

}
goToSaveQuote(){
  
  if(this.agentIdActive=='true'){
    this.router.navigateByUrl('/dashboard/Save-Quotes');
  }else{
    // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
  }
}
goToforms(){
  
  if(this.agentIdActive=='true'){
    this.router.navigateByUrl('/dashboard/forms');
  }else{
    // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
  }
}
goToResources(){
  if(this.agentIdActive=='true'){
    this.router.navigateByUrl('/dashboard/resources');
  }else{
    // Swal.fire("","We require your most up-to-date licenses to allow you to sell. Please upload through 'Documents' option under your Account.","info")
  }

}
getDashboard() {
  this.user.getDashboardData().pipe()
    .subscribe(
      data => {
        this.leadStatus=data.data.leads.leadStatus;
        if(this.leadStatus == 'Deactivated'){
          this.isDisabled = true;
        } else{
          this.isDisabled = false;
        }
       }, error => {
      }, () => { });
}
}
